// ViewBannerModal.tsx

import React from "react";
import { Modal, Text, Button, Group, TextInput } from "@mantine/core";
import { IconPhoto } from "@tabler/icons-react";
import classes from "./view.module.css"; // Use appropriate styles
import { RowDataBanner } from "./types";

interface ViewBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  bannerData: RowDataBanner;
}

const ViewBannerModal: React.FC<ViewBannerModalProps> = ({
  isOpen,
  onClose,
  bannerData,
}) => {
  return (
    <Modal
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          View Banner
        </div>
      }
      opened={isOpen}
      onClose={onClose}
    >
      <TextInput label="Title:" mb="sm" value={bannerData.title} disabled />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span>
      </Text>
      <div className={classes.bannerImageContainer}>
        {bannerData.imageSrc ? (
          <img
            src={bannerData.imageSrc}
            alt="Banner Image"
            className={classes.bannerImageSize}
          />
        ) : (
          <p>
            <IconPhoto />
          </p>
        )}
      </div>

      <TextInput label="Route:" value={bannerData.route ? bannerData.route : ''} disabled />

      <TextInput label="Website Route:" my="sm" value={bannerData.websiteRoute ? bannerData.websiteRoute : ''} disabled />

      {/* <Group className={classes.buttonBottom}>
        <Button onClick={onClose} className={classes.buttonClose}>
          Close
        </Button>
      </Group> */}
    </Modal>
  );
};

export default ViewBannerModal;
